import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { SpinnerService } from '../../spinner/spinner.service';

@Component({
    selector: 'app-bundle-preview-modal',
    templateUrl: './bundle-preview-modal.component.html',
    styleUrls: ['./bundle-preview-modal.component.scss'],
})
export class BundlePreviewModalComponent {
    @Input() data: any;
    modalData: any = [];
    header: any;
    @Input() showSpinner: boolean = true;
    bundlesSubscription$?: Subscription;

    dataFetched: boolean = false;

    constructor(private spinner: SpinnerService) {}

    ngOnInit() {
        setTimeout(() => {
            this.showSpinner = false;
        }, 500);
        console.log('CALLBACK DATA RECEIVED', this?.data);
        this.header = this?.data;
        this.modalData = this?.data.items.map((item: any) => {
            return {
                image: item?.image,
                albumArt: item?.albumArt,
                bannerArt: item?.bannerArt,
                squareArt: item?.squareArt,
                name: item?.name,
                source: item?.source,
                contentType: item?.contentType,
                woiId: item?.woiId,
            };
        });
        this.dataFetched = true;
        console.log(this.modalData);
    }
}
